import { StateRedux } from './type-redux';
import { alerts } from '../utils';

const STATE_REDUX = '@[REDUX-MTRIX-LOGIN]';

export const loadState = (): StateRedux | null => {
  const serializedState = localStorage.getItem(STATE_REDUX);
  if (!serializedState) {
    return null;
  }

  return JSON.parse(serializedState) || null;
};

export const saveState = (state: StateRedux): void => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STATE_REDUX, serializedState);
  } catch (err) {
    alerts.exibirErrorCatch(err);
  }
};

export const deleteState = (): void => {
  localStorage.removeItem(STATE_REDUX);
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('token');
};
